<template>
    <sa-page-layout :btnBackVisible="false" :btnEditVisible="false" :btnRefreshVisible="true" @refresh="onRefresh" :linkback="linkback" :pathResource="pathResource" :showModalLoading="showModalLoading">
        <template slot="table-body">
            <rsa-home-consegne-component ref="cmpRsaHomeConsegne" @beforeLoadData="onBeforeLoadData" @afterLoadData="onAfterLoadData"></rsa-home-consegne-component>
        </template>
    </sa-page-layout>
</template>

<script>
//import SaPageLayout from "../../../../template/sa/components/layout/contents/SaPageLayout.vue";
import SaPageLayout from "../../../../template/sa/components/layout/contents/SaPageLayout.vue";
import UtilityMixin from "../../../utility/UtilityMixin";
import RsaHomeConsegneComponent from "../components/RsaHomeConsegneComponent.vue";

export default {
    mixins: [UtilityMixin],
    components: { SaPageLayout, RsaHomeConsegneComponent },
    data() {
        return {
            pathResource: "/rsadiarivoci/consegne",
            linkback: null,
            showModalLoading: false,
        };
    },
    mounted() {
        let me = this;
        me.loadData();
    },
    methods: {
        onRefresh() {
            let me = this;
            me.loadData();
        },
        loadData() {
            let me = this;
            me.$refs.cmpRsaHomeConsegne.loadData();
        },
        onBeforeLoadData() {
            this.showModalLoading = true;
        },
        onAfterLoadData() {
            this.showModalLoading = false;
        },
    },
};
</script>
<style scoped></style>
